"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapLayerTypeToGeometryType = exports.MapLayerType = void 0;

var _GeoJson = require("./GeoJson");

var _mapLayerTypeToGeomet;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MapLayerType;
exports.MapLayerType = MapLayerType;

(function (MapLayerType) {
  MapLayerType["AERIAL_IMAGERY"] = "aerialimagery";
  MapLayerType["LINE_STRING"] = "LineString";
  MapLayerType["POINT"] = "Point";
  MapLayerType["POLYGON"] = "Polygon";
})(MapLayerType || (exports.MapLayerType = MapLayerType = {}));

var mapLayerTypeToGeometryType = (_mapLayerTypeToGeomet = {}, _defineProperty(_mapLayerTypeToGeomet, MapLayerType.AERIAL_IMAGERY, null), _defineProperty(_mapLayerTypeToGeomet, MapLayerType.LINE_STRING, _GeoJson.GeoJsonGeometryType.LINE_STRING), _defineProperty(_mapLayerTypeToGeomet, MapLayerType.POINT, _GeoJson.GeoJsonGeometryType.POINT), _defineProperty(_mapLayerTypeToGeomet, MapLayerType.POLYGON, _GeoJson.GeoJsonGeometryType.POLYGON), _mapLayerTypeToGeomet);
exports.mapLayerTypeToGeometryType = mapLayerTypeToGeometryType;